'use client'

import { Button, Dialog, DialogContent, Divider, Stack } from '@mui/material'
import {
    OnboardingCapabilitiesSection,
    OnboardingHeader,
    OnboardingIntro,
    OnboardingTryAskingDesktop,
    obVisual,
    type SRPFloatingAIOnboardingCopy
} from './SRPFloatingAIChatOnboardingShared'

export type SRPFloatingAIChatOnboardingDialogProps = {
    open: boolean
    onboardingHeaderHeight: number
    onboardingCopy: SRPFloatingAIOnboardingCopy
    aiChatModeTitle: string
    onContinue: () => void
    onExit: () => void
}

export const SRPFloatingAIChatOnboardingDialog = ({
    open,
    onboardingHeaderHeight,
    onboardingCopy,
    aiChatModeTitle,
    onContinue,
    onExit
}: SRPFloatingAIChatOnboardingDialogProps) => (
    <Dialog
        open={open}
        onClose={onContinue}
        maxWidth="md"
        fullWidth
        slotProps={{
            paper: {
                sx: {
                    borderRadius: 4,
                    overflow: 'hidden',
                    boxShadow: '0 30px 80px -20px rgba(15,27,61,0.45)'
                }
            }
        }}
    >
        <OnboardingHeader
            copy={onboardingCopy}
            aiChatModeTitle={aiChatModeTitle}
            compact={false}
            onboardingHeaderHeight={onboardingHeaderHeight}
            onDismiss={onContinue}
        />
        <DialogContent sx={{ px: 3, pt: 1.5, pb: 3 }}>
            <OnboardingIntro copy={onboardingCopy} />
            <OnboardingCapabilitiesSection copy={onboardingCopy} compact={false} />
            <OnboardingTryAskingDesktop copy={onboardingCopy} />
            <Divider sx={{ my: 2.5 }} />
            <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
                <Button onClick={onExit} sx={{ color: 'text.secondary', textTransform: 'none' }}>
                    {onboardingCopy.exit}
                </Button>
                <Button
                    variant="contained"
                    // endIcon={<ArrowForwardIcon />}
                    onClick={onContinue}
                    sx={{
                        textTransform: 'none',
                        px: 2.5,
                        bgcolor: obVisual.primary,
                        boxShadow: '0 8px 20px -8px rgba(30,58,95,0.5)',
                        '&:hover': { bgcolor: obVisual.primaryDark }
                    }}
                >
                    {onboardingCopy.continue}
                </Button>
            </Stack>
        </DialogContent>
    </Dialog>
)
